/*Third Party Imports Starts*/
import {Form, Field, ErrorMessage} from 'vee-validate';
/*Third Party Imports Ends*/

import ToastificationContent from "@/components/common/ToastificationContent";

import PaymentMain from "@/pages/external-payment/PaymentMain"
import MerchantPayment from "@/pages/external-payment/MerchantPayment"
import PaymentSuccess from "@/pages/external-payment/PaymentSuccess"
import PaymentFailed from "@/pages/external-payment/PaymentFailed"
import PaymentMethod from "@/pages/external-payment/PaymentMethod"

// register components
export const registerComponents = (app) => {

    /*
    |--------------------------------------------------------------------------
    | Third Party Components Registration
    |--------------------------------------------------------------------------
    |
    | Register Your third party Components Here
    |
    */

    // vee validate component registration starts
    app.component('Form', Form)
    app.component('Field', Field)
    app.component('ErrorMessage', ErrorMessage)
    app.component('ToastificationContent', ToastificationContent)
    // vee validate component registration ends




    /*
     * Payment external registration starts*/
     app.component('PaymentMain', PaymentMain);
     app.component('MerchantPayment', MerchantPayment);
     app.component('PaymentSuccess', PaymentSuccess);
     app.component('PaymentFailed', PaymentFailed);
     app.component('PaymentMethod', PaymentMethod);
    /*
     * Payment external registration ends*/





}
